import axios from 'axios';

const BASE_URL = process.env.VUE_APP_HIVER_CHANNELS_MIDDLEWARE_V2;

const getKbDetails = websiteToken => {
  return axios.get(`${BASE_URL}/${websiteToken}/knowledge-base`);
};

const searchKbArticles = (websiteToken, searchQuery) => {
  return axios.get(
    `${BASE_URL}/${websiteToken}/knowledge-base/article/search`,
    {
      params: {
        search_term: searchQuery
      }
    }
  );
};

const getArticleDetails = (websiteToken, articleId) => {
  return axios.get(
    `${BASE_URL}/${websiteToken}/knowledge-base/article/${articleId}`
  );
};

export default {
  getKbDetails,
  searchKbArticles,
  getArticleDetails
};
